module.exports = __webpack_public_path__ + "static/media/Picture1 fleet3.9ce80731.jpg";